import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Manage({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M14 10H12.6667V8.66669L20.6667 0.666687L22 2.00002L14 10Z"
        fill={iconColor}
      />
      <Path
        d="M18.6667 7.21897V20H5.33333V4.00002H15.4477L16.781 2.66669H4.66667C4.29848 2.66669 4 2.96516 4 3.33335V20.6667C4 21.0349 4.29848 21.3334 4.66667 21.3334H19.3333C19.7015 21.3334 20 21.0349 20 20.6667V5.88564L18.6667 7.21897Z"
        fill={iconColor}
      />
      <Path d="M12 6.00002H7.33333V7.33335H12V6.00002Z" fill={iconColor} />
    </Svg>
  );
}
